<template>
    <div class="get-a-demo">
        <a href="/demo" class="get-a-demo__button">{{ trans('demo.get_a_free_demo') }}</a>
    </div>
</template>

<script>
export default {

}
</script>
